<template>
  <div :class="$style.lottery">
    <div
      :class="[
        $style.wheel,
        $style[`wheel-${nums}`],
        showTransition ? $style.hasTransition : '',
      ]"
      ref="wheel"
      :style="{
        transform: `rotate(${deg}deg)`,
        backgroundImage: `url('${cdnUrl}/wheel/${nums}.png?v=1')`,
      }"
    >
      <div
        :class="[$style.wheelItem, $style[`wheel-${nums}-${index}`]]"
        v-for="(item, index) in config.turntables"
        :key="index"
      >
        <p>{{ item.giftName }}</p>
        <img :src="item.iconUrl" alt="" />
      </div>
    </div>
    <div :class="$style.btn" @click="newExtract">
      <!-- <span>剩余: {{ recallState.last_lottery_times }}</span> -->
    </div>
    <span :class="$style.coin">{{ `${coinname}：${recallState.coin}` }}</span>
  </div>
</template>

<script>
import { lottery } from "@/apis/recall";
import { mapState } from "vuex";
import { Toast } from "vant";

const FIXATION = 2160;
const cdnUrl = "//static.hzwxbz3.cn/Lianyun/font_end/ac";

export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
    coinname: {
      type: String,
      default: "",
    },
    activityid: {
      type: Number,
      default: 0,
    },
  },
  name: "",
  data() {
    return {
      cdnUrl,
      showTransition: false,
      giftList: [],
      currentGift: {},
      deg: 0, // 旋转角度
      flag: false, // 是否已经开始抽奖
      timer: null, // 定时器
      res: false, // 清除旋转
      index: 0, // 定在第几栏
      round: 0, // 第几圈
    };
  },
  computed: {
    ...mapState({
      recallState: (state) => state.recall,
    }),
    nums() {
      return this.config.turntableAreaCount < 8 ||
        this.config.turntableAreaCount > 12
        ? 8
        : this.config.turntableAreaCount;
    },
    oneDeg() {
      // 每一圈的角度
      return 360 / this.nums;
    },
  },
  methods: {
    newExtract() {
      const { user_name } = this.recallState;
      if (!user_name) {
        this.$emit("login");
        return;
      }
      if (this.recallState.last_lottery_times == 0) {
        Toast.fail("暂无抽奖次数！");
        return;
      }
      if (this.recallState.coin < this.config.useIntegral) {
        Toast.fail("积分不足！");
        return;
      }
      if (this.flag) return;
      this.deg = 0;
      setTimeout(() => {
        this.showTransition = true;
        this.flag = true;
        this.deg = ++this.round * 360;

        // 请求接口获取获奖信息
        lottery(this.recallState.template_id)
          .then((res) => {
            const { content } = res;
            const { gift_id } = content;
            this.currentGift = content;
            this.res = true;
            this.index = this.config.turntables.findIndex(
              (item) => item.giftId == gift_id
            );
            const addDeg = (this.nums - this.index) * this.oneDeg;
            this.deg += addDeg;
          })
          .catch((err) => {
            this.newReset();
          });

        this.timer = setInterval(() => {
          if (this.res) {
            clearInterval(this.timer);
            this.res = false;
            setTimeout(() => {
              // 中奖后弹窗
              this.$emit(
                "showDialog",
                Object.assign({ activityId: this.activityid }, this.currentGift)
              );
              this.newReset();
              this.flag = false;
            }, 500);
            return;
          }
          this.round++;
          this.deg += 360;
        }, 2000);
      }, 100);
    },
    newReset() {
      this.showTransition = false;
      this.flag = false; // 是否已经开始抽奖
      this.timer = null; // 定时器
      this.res = false; // 清除旋转
      this.index = 0; // 定在第几栏
      this.round = 0; // 第几圈
    },
  },
};
</script>

<style lang="scss" module>
@import "./styles/Lottery.scss";

.lottery {
  margin-top: 0px;
  position: relative;
  text-align: center;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 90px;
    height: 100px;
    margin: auto;
    background: url("#{$cdn-url-recall}/lucky_button_1.png") no-repeat;
    background-size: 100% 100%;
    &:active {
      -webkit-filter: brightness(110%);
      filter: brightness(110%);
    }
    > span {
      color: #ddd9d9;
      font-size: 6px;
      position: absolute;
      bottom: 32px;
      left: 0;
      right: 0;
    }
  }
  .coin {
    position: absolute;
    top: 80px;
    right: 0;
    left: 0;
    bottom: 0;
    width: 86px;
    height: 15px;
    margin: auto;
    color: #ddd9d9;
    background: url("#{$cdn-url-recall}/wheel_back.png") no-repeat;
    background-size: 100% 100%;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wheel {
    // display: inline-block;
    width: 300px;
    height: 300px;
    margin: auto;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    &.hasTransition {
      transition: transform 2s;
      transition-timing-function: linear;
    }
    .wheelItem {
      width: 54px;
      height: 120px;
      padding-top: 6px;
      position: absolute;
      > img {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        object-fit: cover;
      }
      > p {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        line-height: 25px;
        color: #e9d09f;
        margin-bottom: 8px;
      }
    }
  }
  .wheel-10,
  .wheel-11,
  .wheel-12 {
    .wheelItem {
      > img {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>